<template>
  <v-card tile>
    <v-card-title class="font-weight-black mt-5 text-uppercase">
      Projects
    </v-card-title>

    <v-divider role="presentation" class="mb-8"></v-divider>

    <!--<v-flex class="d-flex justify-start mt-8">-->
    <v-card class="mx-auto mb-8" max-width="344">
      <v-img :src="require('@/assets/kingsThumb.png')" :height="200"></v-img>

      <v-card-title>
        Kings Asian Cuisine
      </v-card-title>

      <v-card-subtitle>
        Website for Kings Asian Cuisine, located in Merced, CA
      </v-card-subtitle>

      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          text
          href="https://kingsasiancuisine.com/"
          target="_blank"
        >
          Explore
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text>
        Vuetify, Firebase.
      </v-card-text>
    </v-card>

    <v-card class="mx-auto mb-8" max-width="344">
      <v-img :src="require('@/assets/check.png')" :height="200"></v-img>

      <v-card-title>
        checkPoints
      </v-card-title>

      <v-card-subtitle>
        Webscraper that reports local CA sobriety checks.
      </v-card-subtitle>

      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          text
          href="https://github.com/rizingson/checkPoints"
          target="_blank"
        >
          Explore
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

      <v-divider></v-divider>

      <v-card-text>
        Node.js, Nodemailer, PM2, and MongoDB.
      </v-card-text>
    </v-card>
    <!--</v-flex>-->

    <!-- <v-flex class="d-flex justify-start mt-8">-->
    <v-card class="mx-auto mb-8" max-width="344">
      <v-img :src="require('@/assets/motion.png')" :height="200"></v-img>

      <v-card-title>
        Motion
      </v-card-title>

      <v-card-subtitle>
        CCTV live stream + record on microwave motion detection. Running on
        raspberry pi
      </v-card-subtitle>

      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          text
          href="https://github.com/rizingson/motion"
          target="_blank"
        >
          Explore
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

      <v-divider></v-divider>

      <v-card-text>
        Node.js and Johnny-Five.io, on Raspberry Pi.
      </v-card-text>
    </v-card>
    <!--</v-flex>-->

    <!--<v-flex class="d-flex justify-start mt-8">-->
    <v-btn icon href="https://github.com/rizingson" target="_blank">
      <v-icon class="pa-2">mdi-github</v-icon>
    </v-btn>

    <v-btn icon href="https://www.facebook.com/damon.bonner.33" target="_blank">
      <v-icon class="pa-2">mdi-facebook</v-icon>
    </v-btn>

    <v-btn
      icon
      href="https://www.instagram.com/rizing_son/?hl=en"
      target="_blank"
    >
      <v-icon class="pa-2">mdi-instagram</v-icon>
    </v-btn>

    <v-btn
      icon
      href="https://www.linkedin.com/in/damon-bonner-9a5579178/"
      target="_blank"
    >
      <v-icon class="pa-2">mdi-linkedin</v-icon>
    </v-btn>

    <v-btn icon href="mailto: damonjbonner@gmail.com">
      <v-icon class="pa-2">mdi-email</v-icon>
    </v-btn>
    <!--</v-flex>-->
  </v-card>
</template>

<script>
export default {
  name: "Projects",
  data: () => ({
    show: false,
    show1: false
  })
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
